

import React, { useRef, useState } from 'react';
import './form.css';
import emailjs from 'emailjs-com';

const Form = () => {

//     const [enteredName, setEnteredName] = useState('')
//     const [enteredEmail, setEnteredEmail] = useState('')
//     const [enteredSubject, setEnteredSubject] = useState('')
//     const [enteredMessage, setEnteredMessage] = useState('')

    const form = useRef();
    const [done, setDone] = useState(false);
    const [error, setError] = useState(false)
    
    const sendEmail = (e)=> {
        e.preventDefault();

        emailjs.sendForm('service_eappzbm', 'template_7cvkbtj', form.current, 'SBw-4_3YL0FVlN-te')
        .then(
            (result) => {
                setDone(true)
            },
            (error) => {
                setError(true)
            },
        )
        
        e.target.reset();
    }

  return (
    <form className='form' ref={form} onSubmit={sendEmail}>
        <div className="form-input">
            <input type="text" name='name' placeholder='Enter your Full Name' required/>
        </div>
        <div className="form-input">
            <input type="text" name='email' placeholder='Enter your Email' required/>
        </div>
        <div className="form-input">
            <input type="text" name='subject' placeholder='Subject' required/>
        </div>
        <div className="form-input">
            <textarea name="message" placeholder='Write your Message here..' required></textarea>
        </div>
        <button className="submit-btn" type='submit'>
            Send Feedback
        </button>
        {done && <div className='success'>Thanks for your feedback.</div>}
        {error && <div className='error'>Something went wrong, try again later.</div>}
    </form>
  )
}

export default Form